import React from "react";
import { Flex, Text, Switch } from "@chakra-ui/react";

const BillingCycleToggle = ({ billingCycle, setBillingCycle }) => {
  const isAnnually = billingCycle === "Annually";

  const handleToggle = () => {
    setBillingCycle((prev) => (prev === "Monthly" ? "Annually" : "Monthly"));
  };

  return (
    <Flex align="center" gap={2}>
      <Text
        fontWeight={billingCycle === "Monthly" ? "bold" : "normal"}
        color={billingCycle === "Monthly" ? "blue.600" : "gray.500"}
      >
        Monthly
      </Text>

      <Switch
        isChecked={isAnnually}
        onChange={handleToggle}
        colorScheme="blue"
        size="lg"
      />

      <Text
        fontWeight={billingCycle === "Annually" ? "bold" : "normal"}
        color={billingCycle === "Annually" ? "blue.600" : "gray.500"}
      >
        Annually
      </Text>
    </Flex>
  );
};

export default BillingCycleToggle;
